import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

// Style
import { Panel, FormGroup, FormControl, Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Component
import ListItem from '../ListItem';
import Loader from '../../Loader';
import Link from '../../Link';


// Locale
import messages from '../../../locale/messages';
import { debounce } from '../../../helpers/debounce';
import history from '../../../core/history';

// Image
import addIcon from '/public/SiteIcons/addListIcon.svg';
import noListImage from '/public/SiteImages/noListImage.svg';
import bt from '../../commonStyle.css';
import s from './PanelItem.css';

const PanelItem = ({
  data,
  panelTitle,
  loading,
  searchKey,
  refetch,
  setValue,
  intl
}) => {
  const { formatMessage } = intl;

  const handleSearchChange = useCallback(
    debounce((searchKey) => {
      let variables = {
        searchKey: searchKey && searchKey.toString().trim()
      };
      refetch(variables);
    }, 300),
    [refetch]
  );

  return (
    <div className={cx('manageListingItem')}>
      <div className={s.listFlex}>
        <div className={s.mobileSearchWidth}>
          <FormGroup className={bt.noMargin}>
            <FormControl
              type="text"
              placeholder={formatMessage(messages.searchYourListing)}
              onChange={(e) => setValue(e.target.value)}
              onKeyUp={() => handleSearchChange(searchKey)}
              className={cx(s.formControlInput, s.searchListingInput, 'prefixIconInputRtl')}
              value={searchKey}
            />
          </FormGroup>
        </div>
        <Button onClick={() => history.push('/become-a-host?mode=new')} className={cx(bt.btnPrimary, s.linkCss)}>
          <img src={addIcon} className={cx(s.plusIcon, 'addPlusIcon')} alt="Add" />
          <FormattedMessage {...messages.addListing} />
        </Button>
      </div>

      <Panel className={s.panelHeader} header={panelTitle}>
        {loading && <Loader type="text" />}
        {!loading && (
          <ul className={cx(s.listContainer, 'listLayoutArbic')}>
            {data && data.length > 0 && data.map((item, index) => (
              <ListItem data={item} key={index} refetch={refetch} searchKey={searchKey} />
            ))}
            {data && data.length === 0 && (
              <div className={s.textCenter}>
                <img src={noListImage} alt="No Listings" />
                <div className={s.noListHeading}>
                  <FormattedMessage {...messages.noListHeading} />
                </div>
                <div className={s.noListSubHeading}>
                  <FormattedMessage {...messages.noListSmall} />
                </div>
                <Link to="/become-a-host?mode=new" className={cx(bt.btnPrimary, s.addNewBtn)}>
                  <FormattedMessage {...messages.addNewlisting} />
                </Link>
              </div>
            )}
          </ul>
        )}
      </Panel>
    </div>
  );
};

PanelItem.propTypes = {
  data: PropTypes.array.isRequired,
  panelTitle: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  searchKey: PropTypes.string,
  refetch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(withStyles(bt, s)(PanelItem));